import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Svg } from '@/shared/ui/Svg';
import { routerPath } from '@/shared/config/router';
import ArrowRightIcon from '@/shared/assets/icons/arrow-right.svg';
import styles from './IntakeGroupRow.module.scss';

interface IntakeGroupRowProps {
  group: { id: number; number: number; studentCount: number; title?: string };
  intakeId: number;
  courseId: number;
}

export const IntakeGroupRow: React.FC<IntakeGroupRowProps> = ({ group, intakeId, courseId }) => {
  const navigate = useNavigate();
  const groupLabel = group.title ?? `Group ${group.number}`;

  const handleClick = () => {
    const path = routerPath.teacherCourseGroup
      .replace(':courseId', courseId.toString())
      .replace(':intakeId', intakeId.toString())
      .replace(':groupNumber', group.number.toString());
    navigate(path);
  };

  return (
    <tr className={styles.groupRow} onClick={handleClick}>
      <td className={styles.td}>
        <div className="pl-8">
          <span className="text-black-headline">Group {group.number}</span>
        </div>
      </td>
      <td className={styles.td}>
        <span className="text-black-headline">{groupLabel}</span>
      </td>
      {/* Пустые ячейки-заполнители: в строке группы этих колонок нет. */}
      {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
      <td className={styles.td}></td>
      {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
      <td className={styles.td}></td>
      <td className={styles.td}>
        <div className="flex items-center justify-end">
          <Svg Icon={ArrowRightIcon} width={20} height={20} className="cursor-pointer" />
        </div>
      </td>
    </tr>
  );
};
